import BaseRepository from '@/repositories/base/BaseRepository';

class CampaignInsuranceRepository extends BaseRepository {
	/** 查询保效统计详情 */
	getCampaignInsuranceDataDetail(params: any) {
		return this.get<any>({
			url: '/ebk-dkb-api/campaignInsurance/get-campaign-insurance-data-detail-by-order-serial-id',
			data: params,
		});
	}

	/** 根据推广计划获取保效明细数据-分页 */
	insuranceDailyDataPage(params: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/campaignInsurance/insurance-daily-data-page',
			data: params,
		});
	}
  //赔付发放红包
  compensationRedPacketDispatch(params: any) {
    return this.get<any>({
      url: '/ebk-dkb-api/campaignInsurance/compensation-red-packet-dispatch',
      data: params,
    });
  }

  //查询保效统计列表
  getCampaignInsuranceData(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/campaignInsurance/get-campaign-insurance-data',
      data: params,
    });
  }
}

export default CampaignInsuranceRepository;
